import { useState } from 'react'
import { SpaceModel } from "../../interfaces/Space"
import { isMobile } from "react-device-detect";
import "../../styles/layouts/infocontacts.scss"

type Props = {
    space: SpaceModel | undefined;
}

type LinkPartial = {
    partial: string,
    link: string
}

const facebookRegex = /(^https?:\/\/)?(www.)?(?<res>.*facebook\.com.*)\/?/;
const instagramHttpRegex = /(^https?:\/\/)?(www.)?instagram\.com\/(?<res>[^/]*)\/?/;
const websiteRegex = /(^https?:\/\/)?(www.)?(?<res>.*)\/?/;

const getPartial = (value: string = '', regex: RegExp, ignoreLength: boolean = true): string => {
    if (!value) return '';
    const matchRes = value.trim().match(regex);
    if (matchRes && matchRes.groups) {
        let res = matchRes.groups.res;
        //shitty hack because I suck at regex, non capturing group not working
        if (res.at(-1) === "/") {
            res = res.slice(0, -1);
        }
        if (!ignoreLength && isMobile && res.length > 31) {
            res = `${res.slice(0, 15)}...${res.slice(-15)}`;
        }
        return res;
    }

    return '';
}

const getSimpleCSValues = (value: string | undefined): string[] => {
    if (!value) return [];
    let emails = value.includes(",") ? value.split(',') : [value];
    return emails.map(e => e.trim());
}

const getFacebookFormatted = (space: SpaceModel | undefined): LinkPartial[] => {
    if (!space || !space.properties.facebook) return [];
    const spaceFacebook = space.properties.facebook;
    let facebooks = spaceFacebook.includes(",") ? spaceFacebook.split(',') : [spaceFacebook];
    return facebooks.map((f) => {
        return {
            partial: getPartial(f, facebookRegex, false),
            link: f
        }
    });
}
const getInstagramFormatted = (space: SpaceModel | undefined): LinkPartial[] => {
    if (!space || !space.properties.instagram) return [];
    const spaceInstagram = space.properties.instagram;
    let instagramList = spaceInstagram.includes(',') ? spaceInstagram.split(',') : [spaceInstagram];

    return instagramList.reduce((res: LinkPartial[], il) => {
        if (il.includes("@")) {
            return [...res, { link: il, partial: il }];
        } else {
            return [...res, { link: il, partial: `@${getPartial(il, instagramHttpRegex)}` }]
        }
    }, [])
}
const getWebsiteFormatted = (space: SpaceModel | undefined): LinkPartial[] => {
    if (!space || !space.properties.website) return [];
    let ws = space.properties.website;
    let res = [ws];
    if (ws.includes(',')) {
        res = ws.split(',');
    }

    return res.map((r) => {
        return {
            link: r,
            partial: getPartial(r, websiteRegex, false)
        }
    });
}

export default function InfoContacts({ space }: Props) {

    const [phonePartial] = useState<string[]>(getSimpleCSValues(space?.properties.phone));
    const [emailPartial] = useState<string[]>(getSimpleCSValues(space?.properties.email));
    const [facebookPartial] = useState<LinkPartial[]>(getFacebookFormatted(space));
    const [instagramPartial] = useState<LinkPartial[]>(getInstagramFormatted(space));
    const [websitePartial] = useState<LinkPartial[]>(getWebsiteFormatted(space));


    return <div>
        {space &&
            <div className="contacts-container">
                {!!phonePartial && phonePartial.length > 0 &&
                    <div>
                        <span className='contacts-clickable'>telefone:&nbsp;</span>
                        {phonePartial.map((e) => {
                            return <a key={e} href={`tel:${e}`}>{e}</a>
                        })}
                    </div>}
                {!!emailPartial && emailPartial.length > 0 &&
                    <div>
                        <span className='contacts-clickable'>email:&nbsp;</span>
                        {emailPartial.map((e) => {
                            return <a key={e} href={`mailto:${e}`}>{e}</a>
                        })}
                    </div>}
                {!!space.properties.website &&
                    <div>
                        <span className='contacts-clickable'>website:&nbsp;</span>
                        {websitePartial.map((wsp) => {
                            return <a key={wsp.link} rel="noreferrer" target='_blank' href={wsp.link}>{wsp.partial}</a>
                        })}
                    </div>}
                {!!instagramPartial && instagramPartial.length > 0 &&
                    <div>
                        <span className='contacts-clickable'>instagram:&nbsp;</span>
                        {instagramPartial.map((ip) => {
                            return <a key={ip.link} rel="noreferrer" target='_blank' href={ip.link}>{ip.partial}</a>
                        })}
                    </div>}
                {!!facebookPartial && facebookPartial.length > 0 &&
                    <div>
                        <span className='contacts-clickable'>facebook:&nbsp;</span>
                        {facebookPartial.map((fp) => {
                            return <a key={fp.link} rel="noreferrer" target='_blank' href={fp.link}>{fp.partial}</a>
                        })}
                    </div>}
            </div>}
    </div>
}